// no baseURI

// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
var installedChunks = {
	"/build/js/main.script": 0,
	"components/add-to-cart-sidebar/add-to-cart-sidebar": 0,
	"components/accessibility-tools/accessibility-tools": 0,
	"components/about-saia/about-saia": 0,
	"build/css/swiper": 0,
	"build/css/style": 0,
	"build/css/style-rtl": 0,
	"components/user-profile/user-profile": 0,
	"components/topbar/topbar": 0,
	"components/swiper-carousel/swiper-carousel": 0,
	"components/slideshow/slideshow": 0,
	"components/register-form/register-form": 0,
	"components/program-sidebar/program-sidebar": 0,
	"components/product-sidebar/product-sidebar": 0,
	"components/partners/partners": 0,
	"components/page/page": 0,
	"components/page-title/page-title": 0,
	"components/page-navigation/page-navigation": 0,
	"components/page-footer/page-footer": 0,
	"components/page-content/page-content": 0,
	"components/node-artical/node-artical": 0,
	"components/news-articles/new-articles": 0,
	"components/navbar/navbar": 0,
	"components/navbar-brand/navbar-brand": 0,
	"components/nav/nav": 0,
	"components/nav-user-account/nav-user-account": 0,
	"components/nav-item/nav-item": 0,
	"components/login-form/login-form": 0,
	"components/heading/heading": 0,
	"components/front-page/front-page": 0,
	"components/event-sidebar/event-sidebar": 0,
	"components/dropdown/dropdown": 0,
	"components/dropdown-menu/dropdown-menu": 0,
	"components/course-sidebar/course-sidebar": 0,
	"components/contact-form/contact-form": 0,
	"components/comment-section/comment-section": 0,
	"components/checkout-login-form/checkout-login-form": 0,
	"components/card/card": 0,
	"components/breadcrumb/breadcrumb": 0,
	"components/book-sidebar/book-sidebar": 0
};

// no chunk on demand loading

// no prefetching

// no preloaded

// no HMR

// no HMR manifest

__webpack_require__.O.j = function(chunkId) { return installedChunks[chunkId] === 0; };

// install a JSONP callback for chunk loading
var webpackJsonpCallback = function(parentChunkLoadingFunction, data) {
	var chunkIds = data[0];
	var moreModules = data[1];
	var runtime = data[2];
	// add "moreModules" to the modules object,
	// then flag all "chunkIds" as loaded and fire callback
	var moduleId, chunkId, i = 0;
	if(chunkIds.some(function(id) { return installedChunks[id] !== 0; })) {
		for(moduleId in moreModules) {
			if(__webpack_require__.o(moreModules, moduleId)) {
				__webpack_require__.m[moduleId] = moreModules[moduleId];
			}
		}
		if(runtime) var result = runtime(__webpack_require__);
	}
	if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
	for(;i < chunkIds.length; i++) {
		chunkId = chunkIds[i];
		if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
			installedChunks[chunkId][0]();
		}
		installedChunks[chunkId] = 0;
	}
	return __webpack_require__.O(result);
}

var chunkLoadingGlobal = self["webpackChunksaiaradix"] = self["webpackChunksaiaradix"] || [];
chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));